<template>
  <v-layout row align-center justify-center fill-height>
    <v-form ref="form" lazy-validation>
        <v-alert type="error" dismissible v-model="alert">
          {{ error }}
        </v-alert>
        <v-text-field
          v-model="token"
          :append-icon="show1 ? 'visibility_off' : 'visibility'"
          :rules="tokenRules"
          placeholder="Type in access token here"
          label="Access Token"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          @keyup.enter="toRoute()"
          required
        ></v-text-field>
        <input type="text" style="display:none" />
        <!-- <v-checkbox
          v-model="checkbox"
          :rules="[v => !!v || 'You must agree to continue!']"
          label="Do you agree with iBegoo user policy?"
          required
        ></v-checkbox> -->
        <v-btn

            @click="toRoute()" target="_blank"
          >
            submit
          </v-btn>
          <v-btn @click="toGuest()" disabled target="_blank">Guest Access</v-btn>
        </v-form>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      token: '',
      tokenRules: [ v => !!v || 'Name is required' ],
      checkbox: false,
      alert: false,
      error: null,
      show1: false
    }
  },
  methods: {
    toRoute () {
      if (this.token === 'Xu2019') {
        this.$router.push({name: 'signin', params: {}, query: {}})
      } else {
        this.alert = true
        this.error = 'Invalid Token, please try again'
      }
    },
    toGuest () {
      this.$router.push({name: 'gallery', params: {}, query: {}})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Access.vue